import { createStore } from '@stencil/store';

export const FaqsStore = createStore(<{ current: IWCFaq; faqs: IWCFaqs }>{
  current: null,
  faqs: {
    total: 0,
    faq: [],
  },
});
